import { render, staticRenderFns } from "./sellerRule.vue?vue&type=template&id=4b87a49d&scoped=true&"
import script from "./sellerRule.vue?vue&type=script&lang=js&"
export * from "./sellerRule.vue?vue&type=script&lang=js&"
import style0 from "./sellerRule.vue?vue&type=style&index=0&id=4b87a49d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87a49d",
  null
  
)

export default component.exports